import { ColumnDef } from "@tanstack/react-table";
import { VideoViewCountProps } from "modules/video/video_detail/store/actionType";

export const VideoViewCountTableColumns: ColumnDef<VideoViewCountProps>[] = [
  {
    id: "slNo",
    header: "Sl. No",
    cell: ({ row }) => row.index + 1,
  },
  {
    accessorKey: "id",
    header: () => <span>ID</span>,
    cell: (info) => info.getValue(),
  },
  {
    accessorKey: "user_id",
    header: () => <span>User ID</span>,
    cell: (info) => info.getValue(),
  },
  {
    accessorKey: "video_id",
    header: () => <span>Video ID</span>,
    cell: (info) => info.getValue(),
  },
  {
    accessorKey: "count",
    header: () => <span>View Count</span>,
    cell: (info) => info.getValue(),
  },
];
